module.exports = __webpack_public_path__ + "img/luggage_service_logo.2e38c063.png";